import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// O endereco antigo da Area da Vendedora (/personalizados/area-vendedora: o da entrada em Paginas Internas e o de links ja guardados)
// leva para a pagina propria (/vendedora), mantendo a query (?vendedora=84&loja=8). A rota fica FORA do /personalizados/:slug de
// proposito: assim a tela nunca abre dentro do Central (nem cria aba na barra de abas).
export default function RedirecionaParaPagina() {
    const loc = useLocation();
    return <Navigate to={`/vendedora${loc.search || ''}`} replace />;
}
